// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Y1M01","price":"styles_price__2OSZK","vatLabel":"styles_vatLabel__2owkw"};